<template>
  <div>
    <div class="hideTotal" v-if="operate === 'list'">
      <table-search label-width="65px" @search="fetchList(1)" @reset="handleReset">
        <template v-slot:basic>
          <el-form-item label="合同编号">
            <el-input v-model="query.contractNo" placeholder="请输入合同编号"/>
          </el-form-item>
          <el-form-item label="合同状态">
            <el-select v-model="query.contractStatus" placeholder="请选择合同状态">
              <el-option v-for="(item, index) in $key.contract.contractStatus" :key="index" :label="item.name" :value="item.id"/>
            </el-select>
          </el-form-item>
        </template>
      </table-search>
      <inquery-result :isExport="false"></inquery-result>
      <el-table :data="tableData">
        <el-table-column label="合同编号" prop="contractNo" align="center"/>
        <el-table-column label="合同名称" prop="templateName" align="center"/>
        <el-table-column label="合同主体" prop="" align="center">
          <template slot-scope="scope">
            {{ scope.row.signers.length ? scope.row.signers[0].userName : '' }}
          </template>
        </el-table-column>
        <el-table-column label="订单编号" prop="orderNo" align="center"/>
        <el-table-column label="合同状态" prop="contractStatus" align="center">
          <template slot-scope="scope">
            {{ scope.row.contractStatus | keyFilter('contract', 'contractStatus')}}
          </template>
        </el-table-column>
        <el-table-column label="签署时间" prop="signDate" align="center"/>
        <el-table-column label="操作" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="toHandleDetail(scope.row)">详情</el-button>
            <el-button v-action:confirmAuth v-if="scope.row.contractStatus === 'TO_AUTH'" type="text" @click="open(scope.row)">签署</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 验证码 -->
    <el-dialog :visible.sync="dialogVisible"  width="30%">
      <div class="content">
        <div class="m-b-30">{{ !countDownTime ? '请先获取验证码' : '验证码已发送，请输入验证码' }}</div>
        <div class="check-box">
          <el-input v-model="checkCode" class="m-b-30" placeholder="请输入验证码"/>
          <span @click="getCode" v-if="!countDownTime" :disabled="codeCount > 5" class="code-btn m-l-10">获取验证码</span>
          <span v-else class="m-l-10" style="color:#908E8E;"> {{'已发送(' + countDownTime +'s)'}}</span>
        </div>
        <el-button :loading="loading" type="primary" @click="confirmAuth">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'
function Query () {
  return {
    id: '', // 合同编号
    contractStatus: '', // 合同状态
  }
}
export default {
  name: 'total',
  data () {
    return {
      query: new Query(),
      tableData: [], // 表格数据
      operate: 'list',
      row: {},
      dialogVisible: false,
      checkCode: '', // 验证码
      codeCount: '', // 获取验证码次数
      countDownTime: 0, // 倒计时
      loading: false,
      timer: '', // 计时器
    }
  },
  mounted () {
    this.fetchList(1)
  },
  methods: {
    // 只获取三种状态的合同
    fetchList () {
      let param = {
        contractNo: this.query.contractNo,
        userId: this.$store.state.user.info.userId,
        contractStatusList: this.query.contractStatus ? [this.query.contractStatus] : [ 'TO_AUTH', 'TO_SIGN', 'SIGNED', 'INVALID' ],
      }
      API.contract.contractList(param).then(res => {
        this.tableData = res.data.rows
      })
    },
    // 发起合同签署
    confirmAuth () {
      if (!this.checkCode) {
        this.$message.warning('请输入验证码')
        return false
      }
      const device = JSON.parse(localStorage.getItem('DEVICE'))
      const param = {
        contractNo: this.row.contractNo, // 合同编号
        device: navigator.userAgent.toLowerCase(), // 浏览器版本
        ip: device.cip, // ip地址
        deviceId: device.cid, // 设备id
        location: device.cname, // ip所在地
        macAddress: device.cip,
        checkCode: this.checkCode
      }
      this.loading = true
      API.contract.confirmAuth(param).then(res => {
        this.$message.success('合同签署成功')
        this.loading = false
        this.countDownTime = 0 // 签署成功重置计时器
        clearInterval(this.timer)
        this.close()
      }).catch(er => {
        this.loading = false
        this.countDownTime = 0 // 签署成功重置计时器
        clearInterval(this.timer)
      })
    },
    // 获取验证码
    getCode () {
      // 时间间隔没到
      if (this.countDownTime !== 0) {
        this.$message.warning(`请${this.countDownTime}秒后在试`)
        return false
      }
      const device = JSON.parse(localStorage.getItem('DEVICE'))
      const param = {
        contractNo: this.row.contractNo, // 合同编号
        device: navigator.userAgent.toLowerCase(), // 浏览器版本
        ip: device.cip, // ip地址
        deviceId: device.cid, // 设备id
        location: device.cname, // ip所在地
        macAddress: device.cip,
      }
      API.contract.applyAuth(param).then(res => {
        this.countDownTime = 60
        this.timer = setInterval(() => {
          this.countDownTime--
          if (this.countDownTime <= 0) {
            clearInterval(this.timer)
          }
        }, 1000)
      })
    },
    // 打开验证码获取
    open (row) {
      this.row = row
      this.dialogVisible = true
    },
    // 查看详情
    toHandleDetail (row) {
      var element = document.createElement('a')
      element.setAttribute('href', (window.location.href.indexOf('.ap-ec.cn') !== -1) ? ('https://seed.ap-ec.cn' + row.filePath) : 'http://open.ap88.com:8900' + row.filePath)
      element.setAttribute('target', '_blank')
      element.style.display = 'none'
      document.body.appendChild(element)
      element.click()
      document.body.removeChild(element)
    },
    // 重置搜索
    handleReset () {
      this.query = new Query()
      this.fetchList(1)
    },
    close () {
      this.row = {}
      this.checkCode = ''
      this.dialogVisible = false
      this.fetchList(1)
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  text-align: center;
  ::v-deep .el-input {
    width: 200px;
  }
  .check-box {
    position: relative;
    span {
      position: absolute;
      top: 10px;
    }
  }
}
.code-btn {
  cursor: pointer;
  &:hover {
    color: #f8bd47;
  }
}
</style>
